export default __webpack_public_path__ + "static/media/placeholder_dummy2016-beauty02-de.df8266a3.png";